import { useEffect, useState } from 'react';
import { GameProvider, useGame } from './context/GameContext';
import { HomePage } from './pages/HomePage';
import { LobbyPage } from './pages/LobbyPage';
import { GamePage } from './pages/GamePage';
import { EndPage } from './pages/EndPage';
import { AdminPage } from './pages/AdminPage';
import { ToastContainer } from './components/ToastContainer';

function AppRoutes() {
  const { view, toasts, dismissToast } = useGame();

  return (
    <>
      <ToastContainer toasts={toasts} onDismiss={dismissToast} />
      {view === 'home' && <HomePage />}
      {view === 'lobby' && <LobbyPage />}
      {view === 'game' && <GamePage />}
      {view === 'end' && <EndPage />}
    </>
  );
}

// Hash route (not a path) so the admin page works on any static host
// without SPA-fallback rewrites, and never opens a game socket.
function useIsAdminRoute(): boolean {
  const check = () => window.location.hash === '#/admin';
  const [isAdmin, setIsAdmin] = useState(check);
  useEffect(() => {
    const onHashChange = () => setIsAdmin(check());
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);
  return isAdmin;
}

export default function App() {
  if (useIsAdminRoute()) return <AdminPage />;

  return (
    <GameProvider>
      <AppRoutes />
    </GameProvider>
  );
}
